/**
 * @file
 * > 这是一个HTTP请求类封装文件.
 * @see {@link AxiosAPI}
 * @version 1.0.0
 * @author hejikun
 * @copyright hejikun 2017
 */
import axios from 'axios'
import router from '@/router'
import { Base64 } from 'js-base64'
import { login } from '@/apis/fromBaseApi/user'
import { isThirdPartyEmbed, thirdPartyAuthRedirect } from '@/library/reauth'
import { set } from 'lodash'
import wx from 'weixin-js-sdk'
import store from '@/store/index'
import Vue from 'vue'

const axiosBaseConfig = {
  // axiosApiUrl: window.location.href.indexOf('localhost') > -1
  //   ? 'http://www.dytapi.com'
  //   : window.location.href.indexOf('testapp.ynhdkc.com') > -1
  //     ? 'https://testapi.ynhdkc.com/' : 'https://dytapi.ynhdkc.com/'
  axiosApiUrl:
    window.location.href.indexOf('ttestapp.ynhdkc.com') > -1
      ? 'https://dytapi.ynhdkc.com/'
      : window.location.href.indexOf('refactor-test.ynhdkc.com') > -1 ||
        window.location.href.indexOf('localhost') > -1 ||
        window.location.href.indexOf('test.com') > -1 ||
        window.location.href.indexOf('192.168') > -1
      ? 'https://dytapi.ynhdkc.com/' // 'http://192.168.1.112:8081/'
      : 'https://dytapi.ynhdkc.com/',
  maskApiUrl:
    window.location.href.indexOf('refactor-test.ynhdkc.com') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('test.com') > -1
      ? 'https://appv3-api.ynhdkc.com/dyt-adv-server'
      : 'https://appv3-api.ynhdkc.com/dyt-adv-server',
  newDytApiUrl:
    window.location.href.indexOf('refactor-test.ynhdkc.com') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('test.com') > -1 ||
    window.location.href.indexOf('192.168') > -1
      ? 'https://newdytapi.ynhdkc.com/' // 'https://newdytapi.ynhdkc.com/'
      : 'https://newdytapi.ynhdkc.com/',
  questionnaireApiUrl:
    window.location.href.indexOf('refactor-test.ynhdkc.com') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('test.com') > -1 ||
    window.location.href.indexOf('192.168') > -1
      ? 'https://questionnaire.ynhdkc.com/'
      : 'https://questionnaire.ynhdkc.com/',
  spineApiUrl:
    window.location.href.indexOf('refactor-test.ynhdkc.com') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('test.com') > -1 ||
    window.location.href.indexOf('192.168') > -1
      ? 'https://spine.ynhdkc.com/'
      : 'https://spine.ynhdkc.com/',
  askDocApiUrl:
    window.location.href.indexOf('refactor-test.ynhdkc.com') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('test.com') > -1 ||
    window.location.href.indexOf('192.168') > -1
      ? // ? 'https://ask-doctor-api.ynhdkc.com/'
        'https://newdytapi.ynhdkc.com/ask/'
      : // : 'https://newdytapi.ynhdkc.com/ask'
        'https://newdytapi.ynhdkc.com/ask/',
  service:
    window.location.href.indexOf('refactor-test.ynhdkc.com') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('test.com') > -1
      ? 'https://megacloud.ynhdkc.com/'
      : 'https://appv3-api.ynhdkc.com/',
  askServiceApiUrl:window.location.href.indexOf('localhost') > -1 ||
  window.location.href.indexOf('refactor-test.ynhdkc.com') > -1
    ? 'https://megacloud.ynhdkc.com/apis/v1/online-ask' : 'https://appv3-api.ynhdkc.com/apis/v1/online-ask',
  orgServiceApiUrl: 'https://appv3-api.ynhdkc.com/apis/v1/org-service/',
  cspgServiceApiUrl: 'https://nfdw-api.ynhdkc.com/',
  cspgChatApiUrl: 'https://nfdw-followup-api.ynhdkc.com/',
}
/**
 * @desc
 * > 这是一个HTTP请求类，封装了axios创建实例的方法。
 */
class AxiosAPI {
  /**
   * 创建一个Axios实例。
   * @param {string} baseUrl - 基础URL.
   */
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }
  /**
   * 创建一个axios实例。
   * @return {function} 一个axios实例.
   * @example
   * const axiosApi = new AxiosAPI(axiosConfig.axiosBaseUrl).create()
   */
  create() {
    return axios.create({
      baseURL: this.baseUrl,
      timeout: 60000,
      headers: {
        Accept: 'application/json, text/plain, */*'
      }
    })
  }
}

/**
 * @desc
 * > axiosApi: 这是一个axios实例
 * > 基础地址为: http://dytapi.ynhdkc.com/v1/
 * > 测试地址为: http://testapi.ynhdkc.com/v1/
 * @see {@link AxiosAPI}
 * @example
 * window.axiosBaseApi.post(url).then() ...
 * // vue组件中
 * this.axiosBaseApi.post(url).then() ...
 */

const axiosBaseApi = new AxiosAPI(axiosBaseConfig.axiosApiUrl).create() //实例对象
const askServiceApi = new AxiosAPI(axiosBaseConfig.askServiceApiUrl).create() //实例对象
const maskBaseApi = new AxiosAPI(axiosBaseConfig.maskApiUrl).create()
const newDytApiBaseApi = new AxiosAPI(axiosBaseConfig.newDytApiUrl).create()
const questionnaireBaseApi = new AxiosAPI(axiosBaseConfig.questionnaireApiUrl).create()
const askDocApi = new AxiosAPI(axiosBaseConfig.askDocApiUrl).create()
const spineApi = new AxiosAPI(axiosBaseConfig.spineApiUrl).create()
const service = new AxiosAPI(axiosBaseConfig.service).create()
const orgServiceApi = new AxiosAPI(axiosBaseConfig.orgServiceApiUrl).create()
const cspgServiceApi = new AxiosAPI(axiosBaseConfig.cspgServiceApiUrl).create()
const cspgChatApi = new AxiosAPI(axiosBaseConfig.cspgChatApiUrl).create()

function getUrlParam(name) {
  let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return null
}
// 重新授权
const reaouth = () => {
  store.dispatch('setLoading', false)
  let authToken = localStorage.getItem('authtoken')
  if (!authToken && isThirdPartyEmbed()) {
    thirdPartyAuthRedirect()
    return
  }
  let is_wx = 0
  wx.miniProgram.getEnv((res) => {
    if (res.miniprogram) {
      // 在小程序
      is_wx = 0
    } else {
      // 在公众号
      is_wx = 1
    }
  })
  let data = localStorage.getItem('authtoken')
  if (!data && is_wx === 1) {
    router.push('/user_regiter')
    return
  }
  if (!data && is_wx === 0) {
    const showDialogPath = ['/registration_order_confirm_new', '/bind_mobile', '/ucenter_persons_new', '/physicalExamination_order_confirm']
    if (!showDialogPath.includes(router.currentRoute.path)) return
    Vue.prototype.$dialog.confirm({
      title: '温馨提示',
      message: '您尚未登录，为保证您能使用完整功能，是否先去登录？',
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(() => {
      window.wx.miniProgram.redirectTo({
        url: `/pages/login/index`
      })
    })
    return
  }
  let platform = sessionStorage.getItem('platform')
  let platUserId = sessionStorage.getItem('platUserId')
  let cururl = navigator.userAgent.indexOf('iPhone') === -1 ? window.location.href : localStorage.getItem('DA-LANDPAGE')
  let authinfo = localStorage.getItem('authtoken')
  let authDetail
  if (authinfo) {
    authDetail = JSON.parse(Base64.decode(authinfo.split('.')[1]))
  }
  localStorage.removeItem('authtoken')
  if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
    window.AlipayJSBridge.call(
      'alert',
      {
        message: '用户未注册或授权过期,请点击授权~',
        button: '确定'
      },
      function (e) {
        let data = localStorage.getItem('authtoken')
        if (data) {
          // eslint-disable-next-line no-undef
          my.redirectTo({
            url: `/pages/index/index`
          })
        } else {
          // eslint-disable-next-line no-undef
          my.redirectTo({
            url: '/pages/login/login'
          })
        }
      }
    )
    return
  }
  alert('授权过期，请点击确认重新授权~')
  if (
    navigator.userAgent.indexOf('MicroMessenger') < 0 &&
    (navigator.userAgent.indexOf('Alipay') < 0 || navigator.userAgent.indexOf('AlipayClient') < 0)
  ) {
    router.push('/user_regiter')
    return
  }

  if (platform === 'dytminiapp' && !isThirdPartyEmbed()) {
    if (localStorage.getItem('dzjkk')) {
      localStorage.removeItem('dzjkk')
      window.wx.miniProgram.navigateTo({
        url: `/pages/yunnancn/yunnancn`
      })
    } else {
      window.wx.miniProgram.navigateTo({
        url: `/pages/index/index`
      })
    }
  } else if (platUserId && platform && !isThirdPartyEmbed()) {
    window.location.reload()
  } else {
    let from = ''
    let fromCsfw = sessionStorage.getItem('fromCsfw')
    let url = cururl
    const channel = localStorage.getItem('channel')
    if (authDetail && channel == '2') {
      let redirect_uri = encodeURIComponent(
        `${document.location.protocol}//vote.ynhdkc.com/apis/v1/user/session/users/wechat_callback?redirect=${encodeURIComponent(
          url
        )}&channel=${channel}`
      )
      location.assign(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx324860af71b94a93&redirect_uri=${redirect_uri}&response_type=code&scope=${
          from ? 'snsapi_userinfo' : 'snsapi_base'
        }&state=1#wechat_redirect`
      )
    } else {
      let redirect_uri = encodeURIComponent(
        `${document.location.protocol}//vote.ynhdkc.com/apis/v1/user/session/users/wechat_callback?redirect=${encodeURIComponent(
          url
        )}&channel=${channel}`
      )
      location.assign(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx337dd7b0a2de2ca4&redirect_uri=${redirect_uri}&response_type=code&scope=${
          from ? 'snsapi_userinfo' : 'snsapi_base'
        }&state=1#wechat_redirect`
      )
    }
  }
}

// 请求拦截器 -> 成功
const requestInterceptorSuccess = (config) => {
  // 睡眠问卷不带token
  if(config.baseURL == "https://questionnaire.ynhdkc.com/"){
    return config
  }
  let data = localStorage.getItem('authtoken')
  if (!data) {
    return config
  }
  let authtoken = window.JSON.parse(data)
  authtoken = authtoken.data
  // 设置头部信息，传递 token
  authtoken && (config.headers.Authorization = 'Bearer ' + authtoken)
  config.headers['isNewToken'] = true
  const uuid = sessionStorage.getItem('uuid')
  uuid && (config.headers['x-uuid'] = uuid)
  return config
}

// 行为上报复用认证，不触发业务请求的重新授权或页面跳转。
export const userActionService = new AxiosAPI(axiosBaseConfig.service).create()
userActionService.interceptors.request.use(requestInterceptorSuccess)

const requestInterceptorSuccessTimestamp = (config) => {
  let data = localStorage.getItem('authtoken')
  if (!data) {
    return config
  }
  let authtoken = window.JSON.parse(data)
  authtoken = authtoken.data
  // 设置头部信息，传递 token
  console.log('config',config);
  authtoken && (config.headers.Authorization = 'Bearer ' + authtoken)
  config.headers['isNewToken'] = true
  const uuid = sessionStorage.getItem('uuid')
  uuid && (config.headers['x-uuid'] = uuid)
  config.params = { ...config.params, timestamp: new Date().getTime() }
  return config
}

// 请求拦截器 -> 失败
const requestInterceptorError = (error) => {
  const res = error.response
  if (res && res.status === 401) {
    reaouth()
    return
  }
  return Promise.reject(error)
}

// 响应拦截器 -> 成功
const responseInterceptorSuccess = (res) => {
  if ((res && res.data && res.data.code === 99) || res.status === 401) {
    reaouth()
    return
  } else {
    return res
  }
}

const axiosArr = [
  ['axiosBaseApi', axiosBaseApi],
  ['askServiceApi', askServiceApi],
  ['maskBaseApi', maskBaseApi],
  ['questionnaireBaseApi', questionnaireBaseApi],
  ['spineApi', spineApi],
  ['askDocApi', askDocApi],
  ['service', service],
  ['orgServiceApi', orgServiceApi],
  ['cspgServiceApi', cspgServiceApi],
  ['cspgChatApi', cspgChatApi],
]

newDytApiBaseApi.interceptors.request.use(
  (config) => requestInterceptorSuccessTimestamp(config),
  (error) => requestInterceptorError(error)
)

const axiosMap = new Map(axiosArr)

axiosMap.forEach((item) => {
  item.interceptors.request.use(
    (config) => requestInterceptorSuccess(config),
    (error) => requestInterceptorError(error)
  )
  item.interceptors.response.use(
    (res) => responseInterceptorSuccess(res),
    (error) => {
      const res = error.response
      if (res && res.status === 401) {
        reaouth()
        return
      }
      if (res && res.status === 403) {
        // if (res.data && res.data.message && res.data.message === '用户必须绑定手机号才可使用') {
        //   router.replace('/bind_mobile')
        // }
      }
      return Promise.reject(error)
    }
  )
})

export default {
  axiosBaseApi,
  askServiceApi,
  maskBaseApi,
  newDytApiBaseApi,
  questionnaireBaseApi,
  askDocApi,
  spineApi,
  orgServiceApi,
  service,
  cspgServiceApi,
  cspgChatApi,
}
